import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";
import ReactRoundedImage from "react-rounded-image";
import { clickStreamUser, SessionKeys } from "../utils/AppUtils";
import { Events } from "react-scroll";
import _ from "lodash";
import { getSelectedCatId } from "../redux/courses/actions";
import CONFIG from "../utils/config";
import {
  setCongratClassName,
  setJoyRideReq,
  setShowDropDown,
} from "../redux/assignCourse/actions";
import { myCartClear } from "../redux/Cart/actions";
import { routeList } from "../utils/routeList";
import useLogin from "../custom-hooks/useLogin";
import { impersonateUser, setUserRole, userDetailBroker } from "../redux/user/actions";
import ConfirmModal from "./modal/ConfirmModal";
import { getActiveHeader } from "../redux/home/actions";
import { loginBrokerResponse } from "../redux/auth/actions";
import Loader from "./Loader/Loader";

const ProfileMenuSection = (props) => {
  const myCartRes = useSelector((state) => state.carts.myCart);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const showDropDownRes = useSelector(
    (state) => state.assignCourse.showDropDownRes
  );

  const { signOut, from, renderLoginSignup } = props;
  const { isLoggedIn } = useLogin();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const userRole = useSelector((state) => state.user.role);
  const [cartCount, setCartCount] = useState(0);
  const [roleArray, setRoleArray] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [canShowRole, setCanShowRole] = useState(false);
  const params = window.location.pathname;
  const reaRoleArr = ["coach", "mentor", "team_lead"];
  const [reaRole, setReaRole] = useState([]);
  const [showDropDown, setShowDropDownState] = useState(false);
  const [name, setName] = useState("");

  const congratClassName = useSelector(
    (state) => state.assignCourse.congrat_class_name
  );
  const [blinkEffect, setBlinkEffect] = useState(congratClassName);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      setName(`${authBroker.payload.user.firstname}`);
    }
  }, [authBroker]);

  useEffect(() => {
    if (_.isBoolean(showDropDownRes)) {
      setShowDropDownState(showDropDownRes);
    }
  }, [showDropDownRes]);

  useEffect(() => {
    if (!_.isEmpty(auth)) {
      setReaRole(auth?.authBroker?.payload?.user?.role);
    }
  }, [auth]);

  useEffect(() => {
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      setUserDetails(userDetailRes?.payload?.payload);
    }
  }, [userDetailRes]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      let role = authBroker.payload.user.role;
      setRoleArray(authBroker.payload.user.role);
      if (role.includes("coach")) {
        setCanShowRole(true);
      } else if (role.includes("mentor")) {
        setCanShowRole(true);
      } else if (role.includes("team_lead")) {
        setCanShowRole(true);
      } else {
        setCanShowRole(false);
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(myCartRes)) {
      if (myCartRes?.cart_list?.length > 0)
        setCartCount(myCartRes?.cart_list?.length);
      else dispatch(myCartClear());
    } else {
      setCartCount(0);
    }
  }, [myCartRes]);

  useEffect(() => {
    return () => {
      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
    };
  }, []);

  const goToMenu = (menuName) => {
    dispatch(setShowDropDown(false));
    switch (menuName) {
      case "edit-profile":
        navigate(
          `/profile/edit?section=edit&tab=1&user_id=${localStorage.getItem(
            SessionKeys.USER_ID
          )}`
        );
        // navigate('/change-password');
        clickStreamUser("profile_edit_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "learn":
        navigate("/learn/courses?tab=1");
        clickStreamUser("profile_edit_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "role-request":
        navigate("/accept-role");
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "my-dashboard":
        navigate("/profile/edit?section=dashboard");
        clickStreamUser("profile_dashboard_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "learningCenter":
        navigate("/learning_center");
        clickStreamUser("learning_center_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "videos":
        navigate("/my-videos");
        clickStreamUser("my-videos-menu-click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "events":
        navigate("/my-events");
        clickStreamUser("my-events-menu-click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "favorites":
        dispatch(getSelectedCatId("wishlist"));
        navigate("/wishlist");
        clickStreamUser("my_wishlist_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "notes":
        navigate("/notes");
        clickStreamUser("notes_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "cart":
        navigate(routeList.CART_PAGE);
        clickStreamUser("cart_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "orders":
        navigate("/orders");
        clickStreamUser("orders_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "my-subscription":
        navigate("/my-subscription");
        clickStreamUser("my_subscription_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "credit-points":
        navigate("/credit-points");
        clickStreamUser("credit-points_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "learning-points":
        navigate("/learning-points");
        clickStreamUser("learning-points_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;

      case "my-certificates":
        dispatch(
          userDetailBroker({
            module: "getOrderDetailBroker",
            apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          })
        );
        navigate(
          "/profile/edit?section=edit&tab=6&user_id=" +
            localStorage.getItem(SessionKeys.USER_ID)
        );
        clickStreamUser("my-certificates_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });

        break;
      case "my-badges":
        navigate("/profile/edit?section=badge");
        clickStreamUser("my-certificates_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      // case "learning-path":
      //   navigate("/learning-paths");
      //   clickStreamUser("learning_menu_clicked", {
      //     categoryName: "Learning Paths",
      //     userId: auth.authBroker?.payload?.user.user_id,
      //   });
      //   break;
      case "toolbox":
        navigate("/toolbox?folderId=0");
        clickStreamUser("my-toolbox-clicked", {
          categoryName: "My Toolbox",
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "courses":
        navigate("/my-courses");
        clickStreamUser("my_courses_menu_clicked", {
          categoryName: "Courses",
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "broker-events":
        navigate("/events?source=broker");
        clickStreamUser("broker-events-menu-clicked", {
          categoryName: "Learning Paths",
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "membership":
        navigate("/membership");
        clickStreamUser("upgrade_to_premium_menu_clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "my-onboarding":
        navigate("/my-onboarding");
        clickStreamUser("my_onboarding_menu_clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "report":
        navigate("/report");
        clickStreamUser("report_menu_clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "change-password":
        navigate("/change-password");
        clickStreamUser("change_password_clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "subscription":
        navigate("/my-subscription");
        clickStreamUser("subscription_clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "code-of-request":
        navigate("/codeOfEthics");
        clickStreamUser("code_of_ethics_clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "my-teams":
        navigate("/my-teamlist");
        clickStreamUser("my_teams_clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "leaderboard":
        navigate("/leaderboard");
        clickStreamUser("leaderboard_clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      default:
        clickStreamUser("admin-dashboard-menu-clicked", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        window.open(
          `${CONFIG.API_URL_BROKER_ADMIN}/?br_key=${localStorage.getItem(
            SessionKeys.API_TOKEN_BROKER
          )}`
        );
    }
  };

  let is_impersonated = localStorage.getItem(SessionKeys.IS_IMPERSONATED);

  useEffect(() => {}, [
    is_impersonated || localStorage.getItem(SessionKeys.IS_IMPERSONATED),
  ]);

  const navigateToDetails = () => {
    navigate(routeList.CART_PAGE);
  };

  const premiumIcon = () => {
    return (
      <div className="position-absolute premium-diamond">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9.057"
            height="9.209"
            viewBox="0 0 9.057 9.209"
          >
            <path
              id="diamond-stone"
              d="M8.34,5.223H9.7L7.434,8.446M5.623,5.223H7.434L6.528,8.907M3.358,5.223H4.717l.906,
                        3.223M7.887,2.921h.906L9.7,4.3H8.34M6.075,2.921h.906L7.434,4.3H5.623M4.264,2.921H5.17L4.717,
                        4.3H3.358M3.811,2,2,4.763l4.528,6.446,4.528-6.446L9.245,2Z"
              transform="translate(-2 -2)"
              fill="#6941C6"
            />
          </svg>
        </span>
      </div>
    );
  };

  const impersonatedIcon = () => {
    return (
      <div className="position-absolute premium-diamond">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="rgba(45,45,45,1)"
          >
            <path d="M11.9999 17C15.6623 17 18.8649 18.5751 20.607 20.9247L18.765 21.796C17.3473 20.1157 14.8473 19 11.9999 19C9.15248 19 6.65252 20.1157 5.23479 21.796L3.39355 20.9238C5.13576 18.5747 8.33796 17 11.9999 17ZM11.9999 2C14.7613 2 16.9999 4.23858 16.9999 7V10C16.9999 12.6888 14.8776 14.8818 12.2168 14.9954L11.9999 15C9.23847 15 6.9999 12.7614 6.9999 10V7C6.9999 4.31125 9.1222 2.11818 11.783 2.00462L11.9999 2ZM11.9999 4C10.4022 4 9.09623 5.24892 9.00499 6.82373L8.9999 7V10C8.9999 11.6569 10.343 13 11.9999 13C13.5976 13 14.9036 11.7511 14.9948 10.1763L14.9999 10V7C14.9999 5.34315 13.6567 4 11.9999 4Z"></path>
          </svg>
        </span>
      </div>
    );
  };

  const showTourAndGuide = () => {
    sessionStorage.setItem(SessionKeys.IS_TOUR, "YES");
    if (document.getElementById("idForTour") !== null) {
      document.getElementById("idForTour").classList.add("taketour");
    }

    // dispatch(setJoyRideReq({run: false}));
    // setTimeout(()=>{
    dispatch(
      setJoyRideReq({
        run: true,
        stepIndex: 0,
      })
    );
    // },1500)

    setTimeout(() => {
      var s = document.getElementById("joyRideWelcome");
      if (s !== null) {
        s.innerHTML =
          "Welcome " + localStorage.getItem(SessionKeys.FIRST_NAME) + "!";
      }
    }, 500);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [impersonateAPICalled, setimpersonateAPICalled] = useState(false);
  const impersonateRes = useSelector((state) => state.user.impersonateUserData);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
 

  const stopImpersonating = () => {
    setShowModalMsg(`Are you sure you want to stop the impersonation and switch back to your account?`);
    setIsConfirm(true);
    setConfirmModal(true);
  };

  const confirmAction = () => {
    setimpersonateAPICalled(true);
    setIsLoading(true);
    dispatch(
      impersonateUser({
        module: "impersonate-user",
        postData: {
          user_id: localStorage.getItem(SessionKeys.LOGGED_IN_USER_ID),
          token: localStorage.getItem(SessionKeys.LOGGED_IN_USER_TOKEN),
          action: "stop_imp"
        },
      })
    );
  };
  useEffect(() => {
    if (!_.isEmpty(impersonateRes) && impersonateAPICalled) {
      console.log("check--", impersonateRes);
      if (impersonateRes?.status === "success") {
        let userData = impersonateRes?.payload?.payload?.user_data;
        localStorage.setItem(SessionKeys.IS_IMPERSONATED, false);
        localStorage.removeItem(SessionKeys.LOGGED_IN_USER_TOKEN);
        localStorage.removeItem(SessionKeys.LOGGED_IN_USER_ID);
        localStorage.setItem(
          SessionKeys.API_TOKEN_BROKER,
          impersonateRes?.payload?.payload?.token
        );
        localStorage.setItem(SessionKeys.USER_ID, userData?.user_id);
        localStorage.setItem(SessionKeys.FIRST_NAME, userData?.firstname);
        if (_.isArray( userData?.role)) {
          // console.log("USER ROLE", roleArray);

          if ( userData?.role.includes("customer")) {
            dispatch(setUserRole("customer"));
          } else if ( userData?.role.includes("realtor")) {
            dispatch(setUserRole("realtor"));
          } else if ( userData?.role.includes("manager")) {
            dispatch(setUserRole("manager"));
          } else if ( userData?.role.includes("pmpro_membership_manager")) {
            // console.log("USER ROLE PMPRO", roleArray);
            dispatch(setUserRole("broker"));
          } else if ( userData?.role.includes("instructor")) {
            dispatch(setUserRole("instructor"));
          } else if ( userData?.role.includes("host")) {
            dispatch(setUserRole("host"));
          } else if ( userData?.role.includes("broker_admin")) {
            dispatch(setUserRole("admin"));
          }
        } 
        dispatch(getActiveHeader(""));
        dispatch(
          loginBrokerResponse({
            payload: {
              user: {
                user_id: userData?.user_id,
                username: userData?.username,
                firstname: userData?.firstname,
                middlename: userData?.middlename,
                lastname: userData?.lastname,
                email: userData?.email,
                bot_token: userData?.bot_token,
                ai_roleplay_token: userData?.ai_roleplay_token,
                profile_img: userData?.profile_img,
                isProfileCompleted: userData?.isProfileCompleted,
                isOnboarding: userData?.isOnboarding,
                isPremium: userData?.isPremium,
                profile_img_check: userData?.profile_img_check,
                city: userData?.city,
                state: userData?.state,
                designation: userData?.designation,
                timezone: userData?.timezone,
                timezoneAbbr: userData?.timezoneAbbr,
                profile_complete: userData?.profile_complete,
                broker_id: userData?.broker_id,
                broker_name: userData?.broker_name,
                zoom_id: userData?.zoom_id,
                company_id: userData?.company_id,
                role: userData?.role,
                IsGuest: userData?.IsGuest,
                ip_address: userData?.ip_address,
                broker_of_records: userData?.broker_of_records,
                isagreed: userData?.isagreed,
                complete_tour: userData?.complete_tour,
                guest_end_date: userData?.guest_end_date,
                display_subscription_menu: userData?.display_subscription_menu,
                is_parent: userData?.is_parent,
                parent_name: userData?.parent_name,
                branding: userData?.branding,
                apply_theme: userData?.apply_theme,
                branding_primary_color_1: userData?.branding_primary_color_1,
                branding_primary_color_2: userData?.branding_primary_color_2,
                branding_company_logo: userData?.branding_company_logo,
                is_google_sso_enabled: userData?.is_google_sso_enabled,
                is_ms_sso_enabled: userData?.is_ms_sso_enabled,
                is_sso_enabled: userData?.is_sso_enabled,
                partner_menu: userData?.partner_menu,
                courseURL: userData?.courseURL,
              },
              apiToken: impersonateRes?.payload?.payload?.token,
            },
          })
        );

        navigate("/my-teamlist");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      } else {
      }
      setimpersonateAPICalled(false);
    }
  }, [impersonateRes]);

  const realtorMenu = () => {
    return (
      <>
        <div className="profile-box-user">
          <div className="profile-img-box">
            <img
              src={
                authBroker.payload.user?.profile_img !== undefined &&
                authBroker.payload.user?.profile_img !== ""
                  ? authBroker.payload.user?.profile_img
                  : "/images/avatar.svg"
              }
            />
            <div className="live-dot active-dot"></div>
          </div>
          <div className="profile-info">
            <div className="pro-name">
              {authBroker.payload.user.firstname +
                " " +
                authBroker.payload.user.middlename +
                " " +
                authBroker.payload.user.lastname}
            </div>
            <div className="proemail" title={authBroker.payload.user.email}>
              {authBroker.payload.user.email}
            </div>
          </div>
        </div>
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idMyAccount" + from}
            className="customHover"
            onClick={() => goToMenu("edit-profile")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M13.3333 14C13.3333 13.0696 13.3333 12.6044 13.2185 12.2259C12.96 11.3736 12.293 10.7067 11.4408 10.4482C11.0622 10.3333 10.597 10.3333 9.66665 10.3333H6.33333C5.40295 10.3333 4.93776 10.3333 4.55923 10.4482C3.70696 10.7067 3.04002 11.3736 2.78148 12.2259C2.66666 12.6044 2.66666 13.0696 2.66666 14M11 5C11 6.65685 9.65684 8 7.99999 8C6.34314 8 4.99999 6.65685 4.99999 5C4.99999 3.34315 6.34314 2 7.99999 2C9.65684 2 11 3.34315 11 5Z"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            Profile
          </div>

          {/* <div className="submenuresp">
                        <div className="customHover b-b-1">Profile</div>
                        <div className="customHover b-b-1" onClick={() => goToMenu('my-dashboard')}>Dashboard</div>
                        {!isPremiumUser && <div id={"idUpgradeToPremium" + from} className="customHover b-b-1" onClick={() => goToMenu('membership')}>- Upgrade to Premium</div>}
                        <div id={"idRewardPoints" + from} className="customHover b-b-1" onClick={() => goToMenu('credit-points')}>- Reward Points</div>
                        <div id={"idOrders" + from} className="customHover b-b-1" onClick={() => goToMenu('orders')}>- Orders</div>
                      {authBroker?.payload?.user?.partner_menu ? <div id={"idSubscription" + from} className="customHover b-b-1" onClick={() => goToMenu('subscription')}>- Subscription</div>: "" }  
                        <div id={"idWishList" + from} className="customHover b-b-1" onClick={() => goToMenu('favorites')}>- Wishlist</div>
                        <div className="customHover b-b-1" onClick={() => goToMenu('role-request')}>-  My Network</div>
                    </div> */}
          {/* <NavDropdown.Item className="customHover b-b-1" onClick={() => goToMenu('favorites')}>Wishlist</NavDropdown.Item> */}
        </NavDropdown.Item>
        {localStorage.getItem(SessionKeys.SSO_ENABLED) !== "1" && (
          <NavDropdown.Item
            className={`customHoverdrop ${
              localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
                ? "cursor-not-allowed"
                : ""
            }`}
          >
            <div
              id={"idSettings" + from}
              className="customHover"
              onClick={() =>
                localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
                  ? ""
                  : goToMenu("change-password")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clip-path="url(#clip0_2011_8107)">
                  <path
                    d="M8.00001 9.99998C9.10458 9.99998 10 9.10455 10 7.99998C10 6.89541 9.10458 5.99998 8.00001 5.99998C6.89544 5.99998 6.00001 6.89541 6.00001 7.99998C6.00001 9.10455 6.89544 9.99998 8.00001 9.99998Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.4849 9.81816C12.4042 10.001 12.3801 10.2037 12.4158 10.4003C12.4514 10.5969 12.5451 10.7784 12.6849 10.9212L12.7212 10.9576C12.8339 11.0701 12.9233 11.2038 12.9843 11.351C13.0453 11.4981 13.0767 11.6558 13.0767 11.8151C13.0767 11.9744 13.0453 12.1322 12.9843 12.2793C12.9233 12.4265 12.8339 12.5601 12.7212 12.6727C12.6087 12.7854 12.475 12.8748 12.3278 12.9358C12.1807 12.9968 12.0229 13.0282 11.8636 13.0282C11.7044 13.0282 11.5466 12.9968 11.3995 12.9358C11.2523 12.8748 11.1186 12.7854 11.0061 12.6727L10.9697 12.6363C10.8269 12.4966 10.6455 12.4029 10.4489 12.3673C10.2522 12.3316 10.0495 12.3557 9.86668 12.4363C9.68742 12.5132 9.53455 12.6407 9.42686 12.8033C9.31918 12.9659 9.26139 13.1565 9.26062 13.3515V13.4545C9.26062 13.776 9.13291 14.0843 8.90559 14.3116C8.67828 14.5389 8.36997 14.6666 8.0485 14.6666C7.72702 14.6666 7.41871 14.5389 7.1914 14.3116C6.96408 14.0843 6.83637 13.776 6.83637 13.4545V13.4C6.83168 13.1994 6.76675 13.0048 6.65002 12.8416C6.53328 12.6784 6.37015 12.5541 6.18183 12.4848C5.99903 12.4042 5.79626 12.3801 5.59965 12.4157C5.40305 12.4514 5.22163 12.5451 5.0788 12.6848L5.04243 12.7212C4.92986 12.8339 4.79618 12.9233 4.64903 12.9843C4.50188 13.0453 4.34415 13.0767 4.18486 13.0767C4.02557 13.0767 3.86784 13.0453 3.72069 12.9843C3.57354 12.9233 3.43986 12.8339 3.32728 12.7212C3.21458 12.6086 3.12518 12.4749 3.06418 12.3278C3.00318 12.1806 2.97178 12.0229 2.97178 11.8636C2.97178 11.7043 3.00318 11.5466 3.06418 11.3994C3.12518 11.2523 3.21458 11.1186 3.32728 11.006L3.36365 10.9697C3.50337 10.8268 3.59709 10.6454 3.63274 10.4488C3.66839 10.2522 3.64432 10.0494 3.56365 9.86665C3.48682 9.68739 3.35926 9.53452 3.19666 9.42683C3.03406 9.31915 2.84352 9.26136 2.6485 9.26059H2.54546C2.22399 9.26059 1.91568 9.13288 1.68837 8.90556C1.46105 8.67825 1.33334 8.36994 1.33334 8.04846C1.33334 7.72699 1.46105 7.41868 1.68837 7.19137C1.91568 6.96405 2.22399 6.83634 2.54546 6.83634H2.60001C2.80061 6.83165 2.99516 6.76672 3.15837 6.64999C3.32158 6.53325 3.4459 6.37012 3.51516 6.1818C3.59584 5.999 3.6199 5.79623 3.58426 5.59962C3.54861 5.40302 3.45488 5.2216 3.31516 5.07877L3.2788 5.0424C3.1661 4.92983 3.07669 4.79615 3.0157 4.649C2.9547 4.50185 2.9233 4.34412 2.9233 4.18483C2.9233 4.02554 2.9547 3.86781 3.0157 3.72066C3.07669 3.57351 3.1661 3.43983 3.2788 3.32725C3.39137 3.21455 3.52505 3.12515 3.6722 3.06415C3.81935 3.00315 3.97708 2.97175 4.13637 2.97175C4.29567 2.97175 4.45339 3.00315 4.60054 3.06415C4.74769 3.12515 4.88138 3.21455 4.99395 3.32725L5.03031 3.36362C5.17315 3.50334 5.35457 3.59706 5.55117 3.63271C5.74777 3.66836 5.95055 3.64429 6.13334 3.56362H6.18183C6.36108 3.48679 6.51396 3.35923 6.62164 3.19663C6.72932 3.03403 6.78711 2.84349 6.78789 2.64846V2.54543C6.78789 2.22396 6.91559 1.91565 7.14291 1.68834C7.37023 1.46102 7.67854 1.33331 8.00001 1.33331C8.32148 1.33331 8.62979 1.46102 8.85711 1.68834C9.08443 1.91565 9.21213 2.22396 9.21213 2.54543V2.59998C9.21291 2.795 9.2707 2.98554 9.37838 3.14814C9.48606 3.31074 9.63894 3.43831 9.81819 3.51513C10.001 3.59581 10.2038 3.61987 10.4004 3.58422C10.597 3.54858 10.7784 3.45485 10.9212 3.31513L10.9576 3.27877C11.0702 3.16607 11.2038 3.07666 11.351 3.01566C11.4981 2.95467 11.6559 2.92327 11.8152 2.92327C11.9745 2.92327 12.1322 2.95467 12.2793 3.01566C12.4265 3.07666 12.5602 3.16607 12.6727 3.27877C12.7854 3.39134 12.8748 3.52502 12.9358 3.67217C12.9968 3.81932 13.0282 3.97705 13.0282 4.13634C13.0282 4.29563 12.9968 4.45336 12.9358 4.60051C12.8748 4.74766 12.7854 4.88135 12.6727 4.99392L12.6364 5.03028C12.4967 5.17312 12.4029 5.35453 12.3673 5.55114C12.3316 5.74774 12.3557 5.95052 12.4364 6.13331V6.1818C12.5132 6.36105 12.6408 6.51393 12.8034 6.62161C12.966 6.72929 13.1565 6.78708 13.3515 6.78786H13.4546C13.776 6.78786 14.0843 6.91556 14.3117 7.14288C14.539 7.3702 14.6667 7.67851 14.6667 7.99998C14.6667 8.32145 14.539 8.62976 14.3117 8.85708C14.0843 9.0844 13.776 9.2121 13.4546 9.2121H13.4C13.205 9.21288 13.0145 9.27067 12.8519 9.37835C12.6893 9.48603 12.5617 9.63891 12.4849 9.81816Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2011_8107">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>{" "}
              Change Password
            </div>
          </NavDropdown.Item>
        )}
        {/* <NavDropdown.Item className="customHoverdrop">
                    <div id={"idMyAccount" + from} className="customHover" onClick={() => goToMenu('edit-profile')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8.66668 1.33331L2.72898 8.45855C2.49644 8.7376 2.38017 8.87712 2.37839 8.99495C2.37685 9.09739 2.4225 9.19485 2.50218 9.25924C2.59384 9.33331 2.77546 9.33331 3.1387 9.33331H8.00001L7.33334 14.6666L13.271 7.54141C13.5036 7.26236 13.6198 7.12284 13.6216 7.00501C13.6232 6.90257 13.5775 6.80511 13.4978 6.74072C13.4062 6.66665 13.2246 6.66665 12.8613 6.66665H8.00001L8.66668 1.33331Z" stroke="#344054" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>  Account
                    </div>
                </NavDropdown.Item> */}
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idAchieve" + from}
            className="customHover"
            onClick={() => goToMenu("my-certificates")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="#344054"
            >
              <path d="M12 6.99999C16.4183 6.99999 20 10.5817 20 15C20 19.4183 16.4183 23 12 23C7.58172 23 4 19.4183 4 15C4 10.5817 7.58172 6.99999 12 6.99999ZM12 8.99999C8.68629 8.99999 6 11.6863 6 15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15C18 11.6863 15.3137 8.99999 12 8.99999ZM12 10.5L13.3225 13.1797L16.2798 13.6094L14.1399 15.6953L14.645 18.6406L12 17.25L9.35497 18.6406L9.86012 15.6953L7.72025 13.6094L10.6775 13.1797L12 10.5ZM18 1.99999V4.99999L16.6366 6.13755C15.5305 5.5577 14.3025 5.17884 13.0011 5.04948L13 1.99899L18 1.99999ZM11 1.99899L10.9997 5.04939C9.6984 5.17863 8.47046 5.55735 7.36441 6.13703L6 4.99999V1.99999L11 1.99899Z"></path>
            </svg>{" "}
            Achievements
          </div>
        </NavDropdown.Item>
        {userRole !== "customer" && (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idOrders" + from}
              className="customHover"
              onClick={() => goToMenu("my-teams")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M14.6667 14V12.6667C14.6667 11.4241 13.8168 10.38 12.6667 10.084M10.3333 2.19384C11.3106 2.58943 12 3.54754 12 4.66667C12 5.78579 11.3106 6.7439 10.3333 7.13949M11.3333 14C11.3333 12.7575 11.3333 12.1362 11.1304 11.6462C10.8597 10.9928 10.3406 10.4736 9.68717 10.203C9.19711 10 8.57585 10 7.33334 10H5.33334C4.09083 10 3.46958 10 2.97952 10.203C2.32611 10.4736 1.80698 10.9928 1.53633 11.6462C1.33334 12.1362 1.33334 12.7575 1.33334 14M9.00001 4.66667C9.00001 6.13943 7.8061 7.33333 6.33334 7.33333C4.86058 7.33333 3.66668 6.13943 3.66668 4.66667C3.66668 3.19391 4.86058 2 6.33334 2C7.8061 2 9.00001 3.19391 9.00001 4.66667Z"
                  stroke="#344054"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              My Teams
            </div>
          </NavDropdown.Item>
        )}
        {userRole !== "customer" &&
          localStorage.getItem(SessionKeys.SHOW_MENTER_COACH) !== "false" && (
            <NavDropdown.Item className="customHoverdrop">
              <div
                id={"idOrders" + from}
                className="customHover"
                onClick={() => goToMenu("leaderboard")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="#344054"
                >
                  <path d="M11 4H21V6H11V4ZM6 7V11H4V7H1L5 3L9 7H6ZM6 17H9L5 21L1 17H4V13H6V17ZM11 18H21V20H11V18ZM9 11H21V13H9V11Z"></path>
                </svg>
                Leaderboard
              </div>
            </NavDropdown.Item>
          )}
        {false && (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idMyNetwork" + from}
              className="customHover"
              onClick={() => goToMenu("role-request")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.00001 10.3333H5.00001C4.06964 10.3333 3.60445 10.3333 3.22592 10.4482C2.37365 10.7067 1.7067 11.3736 1.44817 12.2259C1.33334 12.6044 1.33334 13.0696 1.33334 14M12.6667 14V10M10.6667 12H14.6667M9.66668 5C9.66668 6.65685 8.32353 8 6.66668 8C5.00982 8 3.66668 6.65685 3.66668 5C3.66668 3.34315 5.00982 2 6.66668 2C8.32353 2 9.66668 3.34315 9.66668 5Z"
                  stroke="#344054"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>{" "}
              Network
            </div>
          </NavDropdown.Item>
        )}
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idOrders" + from}
            className="customHover"
            onClick={() => goToMenu("orders")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M13.6666 4.85185L7.99998 8M7.99998 8L2.33331 4.85185M7.99998 8L8 14.3333M14 10.7057V5.29431C14 5.06588 14 4.95167 13.9663 4.8498C13.9366 4.75969 13.8879 4.67696 13.8236 4.60717C13.7509 4.52828 13.651 4.47281 13.4514 4.36188L8.51802 1.62114C8.32895 1.5161 8.23442 1.46358 8.1343 1.44299C8.0457 1.42477 7.95431 1.42477 7.8657 1.44299C7.76559 1.46358 7.67105 1.5161 7.48198 1.62114L2.54865 4.36188C2.34896 4.47281 2.24912 4.52828 2.17642 4.60717C2.11211 4.67697 2.06343 4.75969 2.03366 4.84981C2 4.95167 2 5.06588 2 5.29431V10.7057C2 10.9341 2 11.0484 2.03366 11.1502C2.06343 11.2403 2.11211 11.3231 2.17642 11.3929C2.24912 11.4718 2.34897 11.5272 2.54865 11.6382L7.48198 14.3789C7.67105 14.4839 7.76559 14.5365 7.8657 14.557C7.95431 14.5753 8.0457 14.5753 8.1343 14.557C8.23442 14.5365 8.32895 14.4839 8.51802 14.3789L13.4514 11.6382C13.651 11.5272 13.7509 11.4718 13.8236 11.3929C13.8879 11.3231 13.9366 11.2403 13.9663 11.1502C14 11.0484 14 10.9341 14 10.7057Z"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Orders
          </div>
        </NavDropdown.Item>
        {userRole !== "customer" && (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idOrdersMng" + from}
              className="customHover"
              onClick={() => goToMenu("my-subscription")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="#344054"
              >
                <path d="M2 18H9V20H2V18ZM2 11H11V13H2V11ZM2 4H22V6H2V4ZM20.674 13.0251L21.8301 12.634L22.8301 14.366L21.914 15.1711C21.9704 15.4386 22 15.7158 22 16C22 16.2842 21.9704 16.5614 21.914 16.8289L22.8301 17.634L21.8301 19.366L20.674 18.9749C20.2635 19.3441 19.7763 19.6295 19.2391 19.8044L19 21H17L16.7609 19.8044C16.2237 19.6295 15.7365 19.3441 15.326 18.9749L14.1699 19.366L13.1699 17.634L14.086 16.8289C14.0296 16.5614 14 16.2842 14 16C14 15.7158 14.0296 15.4386 14.086 15.1711L13.1699 14.366L14.1699 12.634L15.326 13.0251C15.7365 12.6559 16.2237 12.3705 16.7609 12.1956L17 11H19L19.2391 12.1956C19.7763 12.3705 20.2635 12.6559 20.674 13.0251ZM18 17C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16C17 16.5523 17.4477 17 18 17Z"></path>
              </svg>
              Provider Subscription
            </div>
          </NavDropdown.Item>
        )}
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idWishList" + from}
            className="customHover"
            onClick={() => goToMenu("favorites")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M1.33334 9.66669L7.7615 12.8808C7.84895 12.9245 7.89268 12.9464 7.93854 12.955C7.97917 12.9626 8.02085 12.9626 8.06148 12.955C8.10734 12.9464 8.15107 12.9245 8.23852 12.8808L14.6667 9.66669M1.33334 6.33336L7.7615 3.11928C7.84895 3.07555 7.89268 3.05369 7.93854 3.04508C7.97917 3.03746 8.02085 3.03746 8.06148 3.04508C8.10734 3.05369 8.15107 3.07555 8.23852 3.11928L14.6667 6.33336L8.23852 9.54743C8.15107 9.59116 8.10734 9.61302 8.06148 9.62163C8.02085 9.62925 7.97917 9.62925 7.93854 9.62163C7.89268 9.61302 7.84895 9.59116 7.7615 9.54743L1.33334 6.33336Z"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            Wishlist
          </div>
        </NavDropdown.Item>

        {userRole !== "customer" && (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idCodeOfEthics" + from}
              className="customHover"
              onClick={() => goToMenu("code-of-request")}
            >
              <svg
                height="16"
                width="16"
                version="1.1"
                id="_x32_"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <g>
                  <path
                    class="st0"
                    d="M500.609,322.275l-57.428-162.834c0.135,0.008,0.279,0.025,0.406,0.025
                c39.538,0.677,49.422-20.58,54.566-27.94c7.118-10.171-7.91-20.343-15.816-13.558c-7.906,6.775-29.264,21.011-70.386,2.024
                C374.874,102.875,309.87,73.098,271.92,67.399v-39c0-8.799-7.127-15.921-15.918-15.921c-8.795,0-15.922,7.122-15.922,15.921v39
                c-37.95,5.699-102.953,35.476-140.031,52.593c-41.121,18.987-62.48,4.751-70.386-2.024c-7.906-6.784-22.935,3.388-15.816,13.558
                c5.145,7.36,15.028,28.617,54.566,27.94c0.132,0,0.276-0.017,0.402-0.025L11.391,322.275H0
                c11.497,38.025,46.804,65.736,88.595,65.736c41.786,0,77.093-27.711,88.59-65.736h-11.386l-60.355-171.134
                c37.183-11.467,89.569-31.056,134.636-34.072v24.23h-8.507v267.748H218.37v23.858c-8.715,0-17.569,0-24.874,0
                c-23.354,0-22.663,32.969-22.663,32.969c-19.233,0-28.85,15.101-28.85,33.648h228.033c0-18.546-9.616-33.648-28.845-33.648
                c0,0,0.686-32.969-22.668-32.969c-7.305,0-16.159,0-24.874,0v-23.858h-13.203V141.3h-8.507v-24.23
                c45.072,3.015,97.457,22.604,134.64,34.072l-60.358,171.134h-11.387c11.496,38.025,46.804,65.736,88.59,65.736
                c41.79,0,77.098-27.711,88.594-65.736H500.609z M141.243,322.275H35.948L88.595,173L141.243,322.275z M370.758,322.275L423.41,173
                l52.643,149.275H370.758z"
                    fill="#344054"
                  />
                </g>
              </svg>
              Code of Ethics
            </div>
          </NavDropdown.Item>
        )}
        {userRole !== "customer" && false && (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idMyAccount" + from}
              className="customHover"
              onClick={() => showTourAndGuide()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M18.6175 13.0317C17.7315 13.6424 16.6575 14 15.5 14C12.4624 14 10 11.5376 10 8.5C10 5.46243 12.4624 3 15.5 3C18.5376 3 21 5.46243 21 8.5C21 9.6575 20.6424 10.7315 20.0317 11.6175L22.7071 14.2929L21.2929 15.7071L18.6175 13.0317ZM3 4H8V6H3V4ZM3 11H8V13H3V11ZM3 18H21V20H3V18Z"
                  fill="#344054"
                ></path>
              </svg>
              Take a Tour
            </div>
          </NavDropdown.Item>
        )}
        {userRole !== "customer" &&
          localStorage.getItem(SessionKeys.SHOW_MENTER_COACH) !== "false" && (
            <NavDropdown.Item className="customHoverdrop">
              <div
                id={"idMyAccount" + from}
                className="customHover"
                onClick={() => goToMenu("role-request")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M5.99974 9.33333C5.99974 9.33333 6.87474 10.3333 8.33307 10.3333C9.79141 10.3333 10.6664 9.33333 10.6664 9.33333M10.1664 6H10.1731M6.49974 6H6.50641M8.33307 13.3333C11.4627 13.3333 13.9997 10.7963 13.9997 7.66667C13.9997 4.53705 11.4627 2 8.33307 2C5.20346 2 2.66641 4.53705 2.66641 7.66667C2.66641 8.3 2.7703 8.90906 2.96199 9.47774C3.03412 9.69175 3.07019 9.79875 3.07669 9.88095C3.08312 9.96213 3.07826 10.019 3.05818 10.098C3.03784 10.1779 2.99294 10.261 2.90313 10.4272L1.8127 12.4456C1.65716 12.7335 1.57939 12.8774 1.59679 12.9885C1.61195 13.0853 1.6689 13.1705 1.75252 13.2215C1.84852 13.2801 2.01127 13.2632 2.33677 13.2296L5.75078 12.8767C5.85417 12.866 5.90586 12.8606 5.95298 12.8624C5.99932 12.8642 6.03204 12.8686 6.07723 12.879C6.12318 12.8896 6.18095 12.9118 6.29651 12.9564C6.92854 13.1999 7.61522 13.3333 8.33307 13.3333ZM10.4997 6C10.4997 6.18409 10.3505 6.33333 10.1664 6.33333C9.98231 6.33333 9.83307 6.18409 9.83307 6C9.83307 5.8159 9.98231 5.66667 10.1664 5.66667C10.3505 5.66667 10.4997 5.8159 10.4997 6ZM6.83307 6C6.83307 6.18409 6.68383 6.33333 6.49974 6.33333C6.31564 6.33333 6.16641 6.18409 6.16641 6C6.16641 5.8159 6.31564 5.66667 6.49974 5.66667C6.68383 5.66667 6.83307 5.8159 6.83307 6Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>{" "}
                My Network
              </div>
            </NavDropdown.Item>
          )}
        {/* <NavDropdown.Item className="customHoverdrop">
                    <div id={"idMyAccount" + from} className="customHover" onClick={() => goToMenu('edit-profile')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_2011_8164)">
                            <path d="M6.06001 6.00001C6.21675 5.55446 6.52611 5.17875 6.93331 4.93943C7.34052 4.70012 7.81927 4.61264 8.28479 4.69248C8.75032 4.77233 9.17255 5.01436 9.47673 5.3757C9.7809 5.73703 9.94738 6.19436 9.94668 6.66668C9.94668 8.00001 7.94668 8.66668 7.94668 8.66668M8.00001 11.3333H8.00668M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8.00001C1.33334 4.31811 4.31811 1.33334 8.00001 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z" stroke="#344054" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_2011_8164">
                            <rect width="16" height="16" fill="white"/>
                            </clipPath>
                        </defs>
                        </svg>  Support
                        </div>
                </NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHoverdrop">
                    <div id={"idMyAccount" + from} className="customHover" onClick={() => goToMenu('edit-profile')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.6666 4.85185L7.99998 8M7.99998 8L2.33331 4.85185M7.99998 8L8 14.3333M14 10.7057V5.29431C14 5.06588 14 4.95167 13.9663 4.8498C13.9366 4.75969 13.8879 4.67696 13.8236 4.60717C13.7509 4.52828 13.651 4.47281 13.4514 4.36188L8.51802 1.62114C8.32895 1.5161 8.23442 1.46358 8.1343 1.44299C8.0457 1.42477 7.95431 1.42477 7.8657 1.44299C7.76559 1.46358 7.67105 1.5161 7.48198 1.62114L2.54865 4.36188C2.34896 4.47281 2.24912 4.52828 2.17642 4.60717C2.11211 4.67697 2.06343 4.75969 2.03366 4.84981C2 4.95167 2 5.06588 2 5.29431V10.7057C2 10.9341 2 11.0484 2.03366 11.1502C2.06343 11.2403 2.11211 11.3231 2.17642 11.3929C2.24912 11.4718 2.34897 11.5272 2.54865 11.6382L7.48198 14.3789C7.67105 14.4839 7.76559 14.5365 7.8657 14.557C7.95431 14.5753 8.0457 14.5753 8.1343 14.557C8.23442 14.5365 8.32895 14.4839 8.51802 14.3789L13.4514 11.6382C13.651 11.5272 13.7509 11.4718 13.8236 11.3929C13.8879 11.3231 13.9366 11.2403 13.9663 11.1502C14 11.0484 14 10.9341 14 10.7057Z" stroke="#344054" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>  Abbb
                        </div>
                </NavDropdown.Item> */}
        {authBroker.payload?.user?.config?.learning_points !== "false" && (
          <NavDropdown.Item
            className="customHoverdrop"
            onClick={() => goToMenu("toolbox")}
          >
            <div id={"idMyAccount" + from} className="customHover">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="#344054"
              >
                <path d="M5.32943 3.27152C6.56252 2.83314 7.9923 3.10743 8.97927 4.0944C10.1002 5.21531 10.3019 6.90735 9.5843 8.23378L20.293 18.9436L18.8788 20.3579L8.16982 9.64869C6.84325 10.3668 5.15069 10.1653 4.02952 9.04415C3.04227 8.0569 2.7681 6.62659 3.20701 5.39326L5.44373 7.62994C6.02952 8.21572 6.97927 8.21572 7.56505 7.62994C8.15084 7.04415 8.15084 6.0944 7.56505 5.50862L5.32943 3.27152ZM15.6968 5.15506L18.8788 3.38729L20.293 4.80151L18.5252 7.98349L16.7574 8.33704L14.6361 10.4584L13.2219 9.04415L15.3432 6.92283L15.6968 5.15506ZM8.97927 13.2868L10.3935 14.701L5.09018 20.0043C4.69966 20.3948 4.06649 20.3948 3.67597 20.0043C3.31334 19.6417 3.28744 19.0698 3.59826 18.6773L3.67597 18.5901L8.97927 13.2868Z"></path>
              </svg>{" "}
              ToolBox
            </div>
          </NavDropdown.Item>
        )}
        {authBroker.payload?.user?.config?.learning_points !== "false" && (
          <NavDropdown.Item
            className="customHoverdrop"
            onClick={() => goToMenu("learning-points")}
          >
            <div id={"idMyAccount" + from} className="customHover">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="#344054"
              >
                <path d="M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 5V19H20V5H4ZM6 7H8V9H6V7ZM8 11H6V13H8V11ZM6 15H8V17H6V15ZM18 7H10V9H18V7ZM10 15H18V17H10V15ZM18 11H10V13H18V11Z"></path>
              </svg>{" "}
              Learning Points
            </div>
          </NavDropdown.Item>
        )}
        {
          <NavDropdown.Item
            className="customHoverdrop"
            onClick={() => goToMenu("credit-points")}
          >
            <div id={"idMyAccount" + from} className="customHover">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="#344054"
              >
                <path d="M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM7 6H11V10H7V6ZM7 12H17V14H7V12ZM7 16H17V18H7V16ZM13 7H17V9H13V7Z"></path>
              </svg>{" "}
              Reward Points
            </div>
          </NavDropdown.Item>
        }
        <NavDropdown.Item
          className="customHoverdrop"
          onClick={() => {
            localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true" ?  stopImpersonating():signOut();
          }}
        >
          <div id={"idMyAccount" + from} className="customHover">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6M6 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H6"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            {localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
              ? "Stop Impersonation"
              : "Sign out"}
          </div>
        </NavDropdown.Item>
        {/* <NavDropdown.Item className="customHoverdrop">
                    <div className="customHover" >
                        My Learning
                    </div>
                    <div className="submenuresp"> */}
        {/* <div className="customHover b-b-1">Profile</div> */}
        {/* <div className="customHover b-b-1" onClick={() => goToMenu('my-dashboard')}>Dashboard</div> */}
        {/* <div id={"idOnboarding"+from} className="customHover b-b-1" onClick={() => goToMenu('my-onboarding')}>- Onboarding</div>
                        <div id={"idLearningPath"+from} className="customHover b-b-1" onClick={() => goToMenu('learning-path')}>- Learning Path</div> */}
        {/* <div id={"idMyCourses"+from} className="customHover b-b-1" onClick={() => goToMenu('courses')}>- Courses</div>
                        <div id={"idMyVideos"+from} className="customHover b-b-1" onClick={() => goToMenu('videos')}>- Videos</div>
                        <div id={"idMyEvents"+from} className="customHover b-b-1" onClick={() => goToMenu('events')}>- Events</div> */}
        {/* <div id={"idMyCertificates"+from} className="customHover b-b-1" onClick={() => goToMenu('my-certificates')}>- Certificates</div>
                        <div id={"idMyBadges"+from} className="customHover b-b-1" onClick={() => goToMenu('my-badges')}>- Badges</div>
                        <div id={"idMyLearningPoints"+from} className="customHover b-b-1" onClick={() => goToMenu('learning-points')}>- Learning Points</div> */}
        {/* </div> */}
        {/* <NavDropdown.Item className="customHover b-b-1" onClick={() => goToMenu('favorites')}>Wishlist</NavDropdown.Item> */}
        {/*  </NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('role-request')}>My Team Area</NavDropdown.Item>
                <NavDropdown.Item className="customHover" onClick={() => goToMenu('courses')}>My Courses</NavDropdown.Item>
                <NavDropdown.Item className="customHover" onClick={() => goToMenu('learning-path')}>My Learning Paths</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('cart')}>My Cart</NavDropdown.Item>                 */}
        {/* <NavDropdown.Item className="customHover" href="notifications.html">My Notifications</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('learningCenter')}>My Learning Center</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('broker-events')}>My Broker Events</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('events')}>My Events</NavDropdown.Item>
                {!isPremiumUser && <NavDropdown.Item className="customHover" onClick={() => goToMenu('membership')}>Upgrade to Premium</NavDropdown.Item>} */}
        {/* <NavDropdown.Item id={"idMyToolbox"+from} className="customHover" onClick={() => goToMenu('toolbox')}>My Toolbox</NavDropdown.Item>
                <NavDropdown.Item id={"idMyNetwork"+from} className="customHover" onClick={() => goToMenu('role-request')}>My Network</NavDropdown.Item>  */}
        {/* {localStorage.getItem(SessionKeys.SSO_ENABLED) !== "1" && <NavDropdown.Item id={"idChangePassword" + from} className="customHover" onClick={() => goToMenu('change-password')}>Change Password</NavDropdown.Item>} */}
        {/* {canShowRole ? <NavDropdown.Item className="customHover" onClick={() => goToMenu('report')}>Reports</NavDropdown.Item> : ''} */}
        {/* <NavDropdown.Item className="customHover" onClick={() => { signOut() }}>Logout</NavDropdown.Item> */}
      </>
    );
  };

  const hostInstructorMenu = () => {
    return (
      <>
        <div className="profile-box-user">
          <div className="profile-img-box">
            <img
              src={
                authBroker.payload.user?.profile_img !== undefined &&
                authBroker.payload.user?.profile_img !== ""
                  ? authBroker.payload.user?.profile_img
                  : "/images/avatar.svg"
              }
            />
            <div className="live-dot active-dot"></div>
          </div>
          <div className="profile-info">
            <div className="pro-name">
              {authBroker.payload.user.firstname +
                " " +
                authBroker.payload.user.middlename +
                " " +
                authBroker.payload.user.lastname}
            </div>
            <div className="proemail" title={authBroker.payload.user.email}>
              {authBroker.payload.user.email}
            </div>
          </div>
        </div>
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idMyAccount" + from}
            className="customHover"
            onClick={() => goToMenu("edit-profile")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M13.3333 14C13.3333 13.0696 13.3333 12.6044 13.2185 12.2259C12.96 11.3736 12.293 10.7067 11.4408 10.4482C11.0622 10.3333 10.597 10.3333 9.66665 10.3333H6.33333C5.40295 10.3333 4.93776 10.3333 4.55923 10.4482C3.70696 10.7067 3.04002 11.3736 2.78148 12.2259C2.66666 12.6044 2.66666 13.0696 2.66666 14M11 5C11 6.65685 9.65684 8 7.99999 8C6.34314 8 4.99999 6.65685 4.99999 5C4.99999 3.34315 6.34314 2 7.99999 2C9.65684 2 11 3.34315 11 5Z"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            Profile
          </div>
        </NavDropdown.Item>
        {localStorage.getItem(SessionKeys.SSO_ENABLED) !== "1" && (
          <NavDropdown.Item
            className={`customHoverdrop ${
              localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
                ? "cursor-not-allowed"
                : ""
            }`}
          >
            <div
              id={"idSettings" + from}
              className="customHover"
              onClick={() =>
                localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
                  ? ""
                  : goToMenu("change-password")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clip-path="url(#clip0_2011_8107)">
                  <path
                    d="M8.00001 9.99998C9.10458 9.99998 10 9.10455 10 7.99998C10 6.89541 9.10458 5.99998 8.00001 5.99998C6.89544 5.99998 6.00001 6.89541 6.00001 7.99998C6.00001 9.10455 6.89544 9.99998 8.00001 9.99998Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.4849 9.81816C12.4042 10.001 12.3801 10.2037 12.4158 10.4003C12.4514 10.5969 12.5451 10.7784 12.6849 10.9212L12.7212 10.9576C12.8339 11.0701 12.9233 11.2038 12.9843 11.351C13.0453 11.4981 13.0767 11.6558 13.0767 11.8151C13.0767 11.9744 13.0453 12.1322 12.9843 12.2793C12.9233 12.4265 12.8339 12.5601 12.7212 12.6727C12.6087 12.7854 12.475 12.8748 12.3278 12.9358C12.1807 12.9968 12.0229 13.0282 11.8636 13.0282C11.7044 13.0282 11.5466 12.9968 11.3995 12.9358C11.2523 12.8748 11.1186 12.7854 11.0061 12.6727L10.9697 12.6363C10.8269 12.4966 10.6455 12.4029 10.4489 12.3673C10.2522 12.3316 10.0495 12.3557 9.86668 12.4363C9.68742 12.5132 9.53455 12.6407 9.42686 12.8033C9.31918 12.9659 9.26139 13.1565 9.26062 13.3515V13.4545C9.26062 13.776 9.13291 14.0843 8.90559 14.3116C8.67828 14.5389 8.36997 14.6666 8.0485 14.6666C7.72702 14.6666 7.41871 14.5389 7.1914 14.3116C6.96408 14.0843 6.83637 13.776 6.83637 13.4545V13.4C6.83168 13.1994 6.76675 13.0048 6.65002 12.8416C6.53328 12.6784 6.37015 12.5541 6.18183 12.4848C5.99903 12.4042 5.79626 12.3801 5.59965 12.4157C5.40305 12.4514 5.22163 12.5451 5.0788 12.6848L5.04243 12.7212C4.92986 12.8339 4.79618 12.9233 4.64903 12.9843C4.50188 13.0453 4.34415 13.0767 4.18486 13.0767C4.02557 13.0767 3.86784 13.0453 3.72069 12.9843C3.57354 12.9233 3.43986 12.8339 3.32728 12.7212C3.21458 12.6086 3.12518 12.4749 3.06418 12.3278C3.00318 12.1806 2.97178 12.0229 2.97178 11.8636C2.97178 11.7043 3.00318 11.5466 3.06418 11.3994C3.12518 11.2523 3.21458 11.1186 3.32728 11.006L3.36365 10.9697C3.50337 10.8268 3.59709 10.6454 3.63274 10.4488C3.66839 10.2522 3.64432 10.0494 3.56365 9.86665C3.48682 9.68739 3.35926 9.53452 3.19666 9.42683C3.03406 9.31915 2.84352 9.26136 2.6485 9.26059H2.54546C2.22399 9.26059 1.91568 9.13288 1.68837 8.90556C1.46105 8.67825 1.33334 8.36994 1.33334 8.04846C1.33334 7.72699 1.46105 7.41868 1.68837 7.19137C1.91568 6.96405 2.22399 6.83634 2.54546 6.83634H2.60001C2.80061 6.83165 2.99516 6.76672 3.15837 6.64999C3.32158 6.53325 3.4459 6.37012 3.51516 6.1818C3.59584 5.999 3.6199 5.79623 3.58426 5.59962C3.54861 5.40302 3.45488 5.2216 3.31516 5.07877L3.2788 5.0424C3.1661 4.92983 3.07669 4.79615 3.0157 4.649C2.9547 4.50185 2.9233 4.34412 2.9233 4.18483C2.9233 4.02554 2.9547 3.86781 3.0157 3.72066C3.07669 3.57351 3.1661 3.43983 3.2788 3.32725C3.39137 3.21455 3.52505 3.12515 3.6722 3.06415C3.81935 3.00315 3.97708 2.97175 4.13637 2.97175C4.29567 2.97175 4.45339 3.00315 4.60054 3.06415C4.74769 3.12515 4.88138 3.21455 4.99395 3.32725L5.03031 3.36362C5.17315 3.50334 5.35457 3.59706 5.55117 3.63271C5.74777 3.66836 5.95055 3.64429 6.13334 3.56362H6.18183C6.36108 3.48679 6.51396 3.35923 6.62164 3.19663C6.72932 3.03403 6.78711 2.84349 6.78789 2.64846V2.54543C6.78789 2.22396 6.91559 1.91565 7.14291 1.68834C7.37023 1.46102 7.67854 1.33331 8.00001 1.33331C8.32148 1.33331 8.62979 1.46102 8.85711 1.68834C9.08443 1.91565 9.21213 2.22396 9.21213 2.54543V2.59998C9.21291 2.795 9.2707 2.98554 9.37838 3.14814C9.48606 3.31074 9.63894 3.43831 9.81819 3.51513C10.001 3.59581 10.2038 3.61987 10.4004 3.58422C10.597 3.54858 10.7784 3.45485 10.9212 3.31513L10.9576 3.27877C11.0702 3.16607 11.2038 3.07666 11.351 3.01566C11.4981 2.95467 11.6559 2.92327 11.8152 2.92327C11.9745 2.92327 12.1322 2.95467 12.2793 3.01566C12.4265 3.07666 12.5602 3.16607 12.6727 3.27877C12.7854 3.39134 12.8748 3.52502 12.9358 3.67217C12.9968 3.81932 13.0282 3.97705 13.0282 4.13634C13.0282 4.29563 12.9968 4.45336 12.9358 4.60051C12.8748 4.74766 12.7854 4.88135 12.6727 4.99392L12.6364 5.03028C12.4967 5.17312 12.4029 5.35453 12.3673 5.55114C12.3316 5.74774 12.3557 5.95052 12.4364 6.13331V6.1818C12.5132 6.36105 12.6408 6.51393 12.8034 6.62161C12.966 6.72929 13.1565 6.78708 13.3515 6.78786H13.4546C13.776 6.78786 14.0843 6.91556 14.3117 7.14288C14.539 7.3702 14.6667 7.67851 14.6667 7.99998C14.6667 8.32145 14.539 8.62976 14.3117 8.85708C14.0843 9.0844 13.776 9.2121 13.4546 9.2121H13.4C13.205 9.21288 13.0145 9.27067 12.8519 9.37835C12.6893 9.48603 12.5617 9.63891 12.4849 9.81816Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2011_8107">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>{" "}
              Change Password
            </div>
          </NavDropdown.Item>
        )}

        <NavDropdown.Item
          className="customHoverdrop"
          onClick={() => {
            localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true" ?  stopImpersonating():signOut();
          }}
        >
          <div id={"idMyAccount" + from} className="customHover">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6M6 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H6"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            {localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
              ? "Stop Impersonation"
              : "Sign out"}
          </div>
        </NavDropdown.Item>
      </>
    );
  };

  const managerMenu = () => {
    return (
      <>
        <div className="profile-box-user">
          <div className="profile-img-box">
            <img
              src={
                authBroker.payload.user?.profile_img !== undefined &&
                authBroker.payload.user?.profile_img !== ""
                  ? authBroker.payload.user?.profile_img
                  : "/images/avatar.svg"
              }
            />
            <div className="live-dot active-dot"></div>
          </div>
          <div className="profile-info">
            <div className="pro-name">
              {authBroker.payload.user.firstname +
                " " +
                authBroker.payload.user.middlename +
                " " +
                authBroker.payload.user.lastname}
            </div>
            <div className="proemail" title={authBroker.payload.user.email}>
              {authBroker.payload.user.email}
            </div>
          </div>
        </div>
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idMyAccountMng" + from}
            className="customHover"
            onClick={() => goToMenu("edit-profile")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M13.3333 14C13.3333 13.0696 13.3333 12.6044 13.2185 12.2259C12.96 11.3736 12.293 10.7067 11.4408 10.4482C11.0622 10.3333 10.597 10.3333 9.66665 10.3333H6.33333C5.40295 10.3333 4.93776 10.3333 4.55923 10.4482C3.70696 10.7067 3.04002 11.3736 2.78148 12.2259C2.66666 12.6044 2.66666 13.0696 2.66666 14M11 5C11 6.65685 9.65684 8 7.99999 8C6.34314 8 4.99999 6.65685 4.99999 5C4.99999 3.34315 6.34314 2 7.99999 2C9.65684 2 11 3.34315 11 5Z"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            Profile
          </div>
        </NavDropdown.Item>
        {!isPremiumUser && false && (
          <>
            <NavDropdown.Item className="customHoverdrop">
              <div
                id={"idUpgradeToPremiumMng" + from}
                className="customHover"
                onClick={() => goToMenu("edit-profile")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 9.057 9.209"
                >
                  <path
                    id="diamond-stone"
                    d="M8.34,5.223H9.7L7.434,8.446M5.623,5.223H7.434L6.528,8.907M3.358,5.223H4.717l.906,
                        3.223M7.887,2.921h.906L9.7,4.3H8.34M6.075,2.921h.906L7.434,4.3H5.623M4.264,2.921H5.17L4.717,
                        4.3H3.358M3.811,2,2,4.763l4.528,6.446,4.528-6.446L9.245,2Z"
                    transform="translate(-2 -2)"
                    fill="#344054"
                  />
                </svg>{" "}
                Upgrade to Premium
              </div>
            </NavDropdown.Item>
          </>
        )}

        {localStorage.getItem(SessionKeys.SSO_ENABLED) !== "1" && (
          <NavDropdown.Item
            id={"idSettingsMng" + from}
            className={`customHoverdrop ${
              localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
                ? "cursor-not-allowed"
                : ""
            }`}
            onClick={() =>
              localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
                ? ""
                : goToMenu("change-password")
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clip-path="url(#clip0_873_20832)">
                <path
                  d="M7.99967 10C9.10424 10 9.99967 9.10461 9.99967 8.00004C9.99967 6.89547 9.10424 6.00004 7.99967 6.00004C6.89511 6.00004 5.99967 6.89547 5.99967 8.00004C5.99967 9.10461 6.89511 10 7.99967 10Z"
                  stroke="#344054"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.4845 9.81822C12.4038 10.001 12.3798 10.2038 12.4154 10.4004C12.4511 10.597 12.5448 10.7784 12.6845 10.9213L12.7209 10.9576C12.8336 11.0702 12.923 11.2039 12.984 11.351C13.045 11.4982 13.0764 11.6559 13.0764 11.8152C13.0764 11.9745 13.045 12.1322 12.984 12.2794C12.923 12.4265 12.8336 12.5602 12.7209 12.6728C12.6083 12.7855 12.4746 12.8749 12.3275 12.9359C12.1803 12.9969 12.0226 13.0283 11.8633 13.0283C11.704 13.0283 11.5463 12.9969 11.3991 12.9359C11.252 12.8749 11.1183 12.7855 11.0057 12.6728L10.9694 12.6364C10.8265 12.4967 10.6451 12.403 10.4485 12.3673C10.2519 12.3317 10.0491 12.3557 9.86634 12.4364C9.68709 12.5132 9.53421 12.6408 9.42653 12.8034C9.31885 12.966 9.26106 13.1565 9.26028 13.3516V13.4546C9.26028 13.7761 9.13258 14.0844 8.90526 14.3117C8.67794 14.539 8.36963 14.6667 8.04816 14.6667C7.72668 14.6667 7.41838 14.539 7.19106 14.3117C6.96374 14.0844 6.83604 13.7761 6.83604 13.4546V13.4C6.83135 13.1994 6.76641 13.0049 6.64968 12.8417C6.53295 12.6785 6.36982 12.5542 6.18149 12.4849C5.9987 12.4042 5.79592 12.3801 5.59932 12.4158C5.40271 12.4514 5.2213 12.5452 5.07846 12.6849L5.0421 12.7213C4.92953 12.834 4.79584 12.9234 4.64869 12.9844C4.50154 13.0454 4.34381 13.0768 4.18452 13.0768C4.02523 13.0768 3.8675 13.0454 3.72035 12.9844C3.5732 12.9234 3.43952 12.834 3.32695 12.7213C3.21425 12.6087 3.12484 12.475 3.06384 12.3278C3.00285 12.1807 2.97145 12.023 2.97145 11.8637C2.97145 11.7044 3.00285 11.5467 3.06384 11.3995C3.12484 11.2524 3.21425 11.1187 3.32695 11.0061L3.36331 10.9697C3.50303 10.8269 3.59676 10.6455 3.6324 10.4489C3.66805 10.2523 3.64399 10.0495 3.56331 9.86671C3.48648 9.68745 3.35892 9.53458 3.19632 9.42689C3.03372 9.31921 2.84318 9.26142 2.64816 9.26065H2.54513C2.22365 9.26065 1.91535 9.13294 1.68803 8.90562C1.46071 8.67831 1.33301 8.37 1.33301 8.04853C1.33301 7.72705 1.46071 7.41874 1.68803 7.19143C1.91535 6.96411 2.22365 6.8364 2.54513 6.8364H2.59967C2.80028 6.83171 2.99483 6.76678 3.15804 6.65005C3.32125 6.53332 3.44556 6.37018 3.51483 6.18186C3.5955 5.99906 3.61957 5.79629 3.58392 5.59968C3.54827 5.40308 3.45455 5.22166 3.31483 5.07883L3.27846 5.04247C3.16576 4.92989 3.07636 4.79621 3.01536 4.64906C2.95436 4.50191 2.92296 4.34418 2.92296 4.18489C2.92296 4.0256 2.95436 3.86787 3.01536 3.72072C3.07636 3.57357 3.16576 3.43989 3.27846 3.32731C3.39104 3.21461 3.52472 3.12521 3.67187 3.06421C3.81902 3.00321 3.97675 2.97181 4.13604 2.97181C4.29533 2.97181 4.45306 3.00321 4.60021 3.06421C4.74736 3.12521 4.88104 3.21461 4.99361 3.32731L5.02998 3.36368C5.17281 3.5034 5.35423 3.59712 5.55083 3.63277C5.74744 3.66842 5.95021 3.64435 6.13301 3.56368H6.18149C6.36075 3.48685 6.51362 3.35929 6.62131 3.19669C6.72899 3.03409 6.78678 2.84355 6.78755 2.64853V2.5455C6.78755 2.22402 6.91526 1.91571 7.14258 1.6884C7.36989 1.46108 7.6782 1.33337 7.99967 1.33337C8.32115 1.33337 8.62946 1.46108 8.85677 1.6884C9.08409 1.91571 9.2118 2.22402 9.2118 2.5455V2.60004C9.21257 2.79506 9.27036 2.9856 9.37804 3.1482C9.48573 3.3108 9.6386 3.43837 9.81786 3.51519C10.0007 3.59587 10.2034 3.61993 10.4 3.58429C10.5966 3.54864 10.7781 3.45491 10.9209 3.31519L10.9573 3.27883C11.0698 3.16613 11.2035 3.07673 11.3507 3.01573C11.4978 2.95473 11.6555 2.92333 11.8148 2.92333C11.9741 2.92333 12.1318 2.95473 12.279 3.01573C12.4261 3.07673 12.5598 3.16613 12.6724 3.27883C12.7851 3.3914 12.8745 3.52509 12.9355 3.67223C12.9965 3.81938 13.0279 3.97711 13.0279 4.1364C13.0279 4.2957 12.9965 4.45343 12.9355 4.60057C12.8745 4.74772 12.7851 4.88141 12.6724 4.99398L12.636 5.03034C12.4963 5.17318 12.4026 5.3546 12.3669 5.5512C12.3313 5.7478 12.3554 5.95058 12.436 6.13337V6.18186C12.5129 6.36111 12.6404 6.51399 12.803 6.62167C12.9656 6.72936 13.1562 6.78714 13.3512 6.78792H13.4542C13.7757 6.78792 14.084 6.91563 14.3113 7.14294C14.5386 7.37026 14.6663 7.67857 14.6663 8.00004C14.6663 8.32152 14.5386 8.62982 14.3113 8.85714C14.084 9.08446 13.7757 9.21216 13.4542 9.21216H13.3997C13.2047 9.21294 13.0141 9.27073 12.8515 9.37841C12.6889 9.48609 12.5613 9.63897 12.4845 9.81822Z"
                  stroke="#344054"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_873_20832">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>{" "}
            Change Password
          </NavDropdown.Item>
        )}

        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idAchieveMng" + from}
            className="customHover"
            onClick={() => goToMenu("my-certificates")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="#344054"
            >
              <path d="M12 6.99999C16.4183 6.99999 20 10.5817 20 15C20 19.4183 16.4183 23 12 23C7.58172 23 4 19.4183 4 15C4 10.5817 7.58172 6.99999 12 6.99999ZM12 8.99999C8.68629 8.99999 6 11.6863 6 15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15C18 11.6863 15.3137 8.99999 12 8.99999ZM12 10.5L13.3225 13.1797L16.2798 13.6094L14.1399 15.6953L14.645 18.6406L12 17.25L9.35497 18.6406L9.86012 15.6953L7.72025 13.6094L10.6775 13.1797L12 10.5ZM18 1.99999V4.99999L16.6366 6.13755C15.5305 5.5577 14.3025 5.17884 13.0011 5.04948L13 1.99899L18 1.99999ZM11 1.99899L10.9997 5.04939C9.6984 5.17863 8.47046 5.55735 7.36441 6.13703L6 4.99999V1.99999L11 1.99899Z"></path>
            </svg>{" "}
            Achievements
          </div>
        </NavDropdown.Item>

        {userRole !== "customer" && (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idOrdersMng" + from}
              className="customHover"
              onClick={() => goToMenu("my-teams")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M14.6667 14V12.6667C14.6667 11.4241 13.8168 10.38 12.6667 10.084M10.3333 2.19384C11.3106 2.58943 12 3.54754 12 4.66667C12 5.78579 11.3106 6.7439 10.3333 7.13949M11.3333 14C11.3333 12.7575 11.3333 12.1362 11.1304 11.6462C10.8597 10.9928 10.3406 10.4736 9.68717 10.203C9.19711 10 8.57585 10 7.33334 10H5.33334C4.09083 10 3.46958 10 2.97952 10.203C2.32611 10.4736 1.80698 10.9928 1.53633 11.6462C1.33334 12.1362 1.33334 12.7575 1.33334 14M9.00001 4.66667C9.00001 6.13943 7.8061 7.33333 6.33334 7.33333C4.86058 7.33333 3.66668 6.13943 3.66668 4.66667C3.66668 3.19391 4.86058 2 6.33334 2C7.8061 2 9.00001 3.19391 9.00001 4.66667Z"
                  stroke="#344054"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              My Teams
            </div>
          </NavDropdown.Item>
        )}
        {userRole !== "customer" &&
          localStorage.getItem(SessionKeys.SHOW_MENTER_COACH) !== "false" && (
            <NavDropdown.Item className="customHoverdrop">
              <div
                id={"idOrders" + from}
                className="customHover"
                onClick={() => goToMenu("leaderboard")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="#344054"
                >
                  <path d="M11 4H21V6H11V4ZM6 7V11H4V7H1L5 3L9 7H6ZM6 17H9L5 21L1 17H4V13H6V17ZM11 18H21V20H11V18ZM9 11H21V13H9V11Z"></path>
                </svg>
                Leaderboard
              </div>
            </NavDropdown.Item>
          )}

        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idOrdersMng" + from}
            className="customHover"
            onClick={() => goToMenu("orders")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M13.6666 4.85185L7.99998 8M7.99998 8L2.33331 4.85185M7.99998 8L8 14.3333M14 10.7057V5.29431C14 5.06588 14 4.95167 13.9663 4.8498C13.9366 4.75969 13.8879 4.67696 13.8236 4.60717C13.7509 4.52828 13.651 4.47281 13.4514 4.36188L8.51802 1.62114C8.32895 1.5161 8.23442 1.46358 8.1343 1.44299C8.0457 1.42477 7.95431 1.42477 7.8657 1.44299C7.76559 1.46358 7.67105 1.5161 7.48198 1.62114L2.54865 4.36188C2.34896 4.47281 2.24912 4.52828 2.17642 4.60717C2.11211 4.67697 2.06343 4.75969 2.03366 4.84981C2 4.95167 2 5.06588 2 5.29431V10.7057C2 10.9341 2 11.0484 2.03366 11.1502C2.06343 11.2403 2.11211 11.3231 2.17642 11.3929C2.24912 11.4718 2.34897 11.5272 2.54865 11.6382L7.48198 14.3789C7.67105 14.4839 7.76559 14.5365 7.8657 14.557C7.95431 14.5753 8.0457 14.5753 8.1343 14.557C8.23442 14.5365 8.32895 14.4839 8.51802 14.3789L13.4514 11.6382C13.651 11.5272 13.7509 11.4718 13.8236 11.3929C13.8879 11.3231 13.9366 11.2403 13.9663 11.1502C14 11.0484 14 10.9341 14 10.7057Z"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Orders
          </div>
        </NavDropdown.Item>
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idOrdersMng" + from}
            className="customHover"
            onClick={() => goToMenu("my-subscription")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="#344054"
            >
              <path d="M2 18H9V20H2V18ZM2 11H11V13H2V11ZM2 4H22V6H2V4ZM20.674 13.0251L21.8301 12.634L22.8301 14.366L21.914 15.1711C21.9704 15.4386 22 15.7158 22 16C22 16.2842 21.9704 16.5614 21.914 16.8289L22.8301 17.634L21.8301 19.366L20.674 18.9749C20.2635 19.3441 19.7763 19.6295 19.2391 19.8044L19 21H17L16.7609 19.8044C16.2237 19.6295 15.7365 19.3441 15.326 18.9749L14.1699 19.366L13.1699 17.634L14.086 16.8289C14.0296 16.5614 14 16.2842 14 16C14 15.7158 14.0296 15.4386 14.086 15.1711L13.1699 14.366L14.1699 12.634L15.326 13.0251C15.7365 12.6559 16.2237 12.3705 16.7609 12.1956L17 11H19L19.2391 12.1956C19.7763 12.3705 20.2635 12.6559 20.674 13.0251ZM18 17C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16C17 16.5523 17.4477 17 18 17Z"></path>
            </svg>
            Provider Subscription
          </div>
        </NavDropdown.Item>
        {(authBroker?.payload?.user?.partner_menu && false) ? (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idSubscriptionMng" + from}
              className="customHover"
              onClick={() => goToMenu("subscription")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="#344054"
              >
                <path d="M2 18H9V20H2V18ZM2 11H11V13H2V11ZM2 4H22V6H2V4ZM20.674 13.0251L21.8301 12.634L22.8301 14.366L21.914 15.1711C21.9704 15.4386 22 15.7158 22 16C22 16.2842 21.9704 16.5614 21.914 16.8289L22.8301 17.634L21.8301 19.366L20.674 18.9749C20.2635 19.3441 19.7763 19.6295 19.2391 19.8044L19 21H17L16.7609 19.8044C16.2237 19.6295 15.7365 19.3441 15.326 18.9749L14.1699 19.366L13.1699 17.634L14.086 16.8289C14.0296 16.5614 14 16.2842 14 16C14 15.7158 14.0296 15.4386 14.086 15.1711L13.1699 14.366L14.1699 12.634L15.326 13.0251C15.7365 12.6559 16.2237 12.3705 16.7609 12.1956L17 11H19L19.2391 12.1956C19.7763 12.3705 20.2635 12.6559 20.674 13.0251ZM18 17C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16C17 16.5523 17.4477 17 18 17Z"></path>
              </svg>
              Subscription
            </div>
          </NavDropdown.Item>
        ) : (
          ""
        )}
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idWishListMng" + from}
            className="customHover"
            onClick={() => goToMenu("favorites")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M1.33334 9.66669L7.7615 12.8808C7.84895 12.9245 7.89268 12.9464 7.93854 12.955C7.97917 12.9626 8.02085 12.9626 8.06148 12.955C8.10734 12.9464 8.15107 12.9245 8.23852 12.8808L14.6667 9.66669M1.33334 6.33336L7.7615 3.11928C7.84895 3.07555 7.89268 3.05369 7.93854 3.04508C7.97917 3.03746 8.02085 3.03746 8.06148 3.04508C8.10734 3.05369 8.15107 3.07555 8.23852 3.11928L14.6667 6.33336L8.23852 9.54743C8.15107 9.59116 8.10734 9.61302 8.06148 9.62163C8.02085 9.62925 7.97917 9.62925 7.93854 9.62163C7.89268 9.61302 7.84895 9.59116 7.7615 9.54743L1.33334 6.33336Z"
                stroke="#344054"
                strokeWidth="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
            Wishlist
          </div>
        </NavDropdown.Item>
        <NavDropdown.Item className="customHoverdrop">
          <div
            id={"idMyReportMng" + from}
            className="customHover"
            onClick={() => goToMenu("report")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 88 88"
              fill="none"
            >
              <path
                d="M66 77L60.8667 71.775L66.6417 66H44V58.6666H66.6417L60.8667 52.8L66 47.6666L80.6667 62.3333L66 77ZM77 40.3333H69.6667V18.3333H62.3333V29.3333H25.6667V18.3333H18.3333V69.6666H36.6667V77H18.3333C16.3167 77 14.5903 76.2819 13.1542 74.8458C11.7181 73.4097 11 71.6833 11 69.6666V18.3333C11 16.3166 11.7181 14.5902 13.1542 13.1541C14.5903 11.718 16.3167 11 18.3333 11H33.6417C34.3139 8.86107 35.6278 7.10413 37.5833 5.72913C39.5389 4.35413 41.6778 3.66663 44 3.66663C46.4444 3.66663 48.6292 4.35413 50.5542 5.72913C52.4792 7.10413 53.7778 8.86107 54.45 11H69.6667C71.6833 11 73.4097 11.718 74.8458 13.1541C76.2819 14.5902 77 16.3166 77 18.3333V40.3333ZM44 18.3333C45.0389 18.3333 45.9097 17.9819 46.6125 17.2791C47.3153 16.5763 47.6667 15.7055 47.6667 14.6666C47.6667 13.6277 47.3153 12.7569 46.6125 12.0541C45.9097 11.3513 45.0389 11 44 11C42.9611 11 42.0903 11.3513 41.3875 12.0541C40.6847 12.7569 40.3333 13.6277 40.3333 14.6666C40.3333 15.7055 40.6847 16.5763 41.3875 17.2791C42.0903 17.9819 42.9611 18.3333 44 18.3333Z"
                fill="#344054"
              />
            </svg>
            Reports
          </div>
        </NavDropdown.Item>

        {userRole !== "customer" && (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idMyAccount" + from}
              className="customHover"
              onClick={() => goToMenu("code-of-request")}
            >
              <svg
                height="16"
                width="16"
                version="1.1"
                id="_x32_"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <g>
                  <path
                    class="st0"
                    d="M500.609,322.275l-57.428-162.834c0.135,0.008,0.279,0.025,0.406,0.025
                c39.538,0.677,49.422-20.58,54.566-27.94c7.118-10.171-7.91-20.343-15.816-13.558c-7.906,6.775-29.264,21.011-70.386,2.024
                C374.874,102.875,309.87,73.098,271.92,67.399v-39c0-8.799-7.127-15.921-15.918-15.921c-8.795,0-15.922,7.122-15.922,15.921v39
                c-37.95,5.699-102.953,35.476-140.031,52.593c-41.121,18.987-62.48,4.751-70.386-2.024c-7.906-6.784-22.935,3.388-15.816,13.558
                c5.145,7.36,15.028,28.617,54.566,27.94c0.132,0,0.276-0.017,0.402-0.025L11.391,322.275H0
                c11.497,38.025,46.804,65.736,88.595,65.736c41.786,0,77.093-27.711,88.59-65.736h-11.386l-60.355-171.134
                c37.183-11.467,89.569-31.056,134.636-34.072v24.23h-8.507v267.748H218.37v23.858c-8.715,0-17.569,0-24.874,0
                c-23.354,0-22.663,32.969-22.663,32.969c-19.233,0-28.85,15.101-28.85,33.648h228.033c0-18.546-9.616-33.648-28.845-33.648
                c0,0,0.686-32.969-22.668-32.969c-7.305,0-16.159,0-24.874,0v-23.858h-13.203V141.3h-8.507v-24.23
                c45.072,3.015,97.457,22.604,134.64,34.072l-60.358,171.134h-11.387c11.496,38.025,46.804,65.736,88.59,65.736
                c41.79,0,77.098-27.711,88.594-65.736H500.609z M141.243,322.275H35.948L88.595,173L141.243,322.275z M370.758,322.275L423.41,173
                l52.643,149.275H370.758z"
                    fill="#344054"
                  />
                </g>
              </svg>
              Code of Ethics
            </div>
          </NavDropdown.Item>
        )}

        {userRole !== "customer" &&
          localStorage.getItem(SessionKeys.SHOW_MENTER_COACH) !== "false" && (
            <NavDropdown.Item className="customHoverdrop">
              <div
                id={"idMyCommunityMng" + from}
                className="customHover"
                onClick={() => goToMenu("role-request")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M5.99974 9.33333C5.99974 9.33333 6.87474 10.3333 8.33307 10.3333C9.79141 10.3333 10.6664 9.33333 10.6664 9.33333M10.1664 6H10.1731M6.49974 6H6.50641M8.33307 13.3333C11.4627 13.3333 13.9997 10.7963 13.9997 7.66667C13.9997 4.53705 11.4627 2 8.33307 2C5.20346 2 2.66641 4.53705 2.66641 7.66667C2.66641 8.3 2.7703 8.90906 2.96199 9.47774C3.03412 9.69175 3.07019 9.79875 3.07669 9.88095C3.08312 9.96213 3.07826 10.019 3.05818 10.098C3.03784 10.1779 2.99294 10.261 2.90313 10.4272L1.8127 12.4456C1.65716 12.7335 1.57939 12.8774 1.59679 12.9885C1.61195 13.0853 1.6689 13.1705 1.75252 13.2215C1.84852 13.2801 2.01127 13.2632 2.33677 13.2296L5.75078 12.8767C5.85417 12.866 5.90586 12.8606 5.95298 12.8624C5.99932 12.8642 6.03204 12.8686 6.07723 12.879C6.12318 12.8896 6.18095 12.9118 6.29651 12.9564C6.92854 13.1999 7.61522 13.3333 8.33307 13.3333ZM10.4997 6C10.4997 6.18409 10.3505 6.33333 10.1664 6.33333C9.98231 6.33333 9.83307 6.18409 9.83307 6C9.83307 5.8159 9.98231 5.66667 10.1664 5.66667C10.3505 5.66667 10.4997 5.8159 10.4997 6ZM6.83307 6C6.83307 6.18409 6.68383 6.33333 6.49974 6.33333C6.31564 6.33333 6.16641 6.18409 6.16641 6C6.16641 5.8159 6.31564 5.66667 6.49974 5.66667C6.68383 5.66667 6.83307 5.8159 6.83307 6Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>{" "}
                My Network
              </div>
            </NavDropdown.Item>
          )}

        {userRole !== "customer" && false && (
          <NavDropdown.Item className="customHoverdrop">
            <div
              id={"idMyAccount" + from}
              className="customHover"
              onClick={() => showTourAndGuide()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M18.6175 13.0317C17.7315 13.6424 16.6575 14 15.5 14C12.4624 14 10 11.5376 10 8.5C10 5.46243 12.4624 3 15.5 3C18.5376 3 21 5.46243 21 8.5C21 9.6575 20.6424 10.7315 20.0317 11.6175L22.7071 14.2929L21.2929 15.7071L18.6175 13.0317ZM3 4H8V6H3V4ZM3 11H8V13H3V11ZM3 18H21V20H3V18Z"
                  fill="#344054"
                ></path>
              </svg>
              Take a Tour
            </div>
          </NavDropdown.Item>
        )}
        {/* <NavDropdown.Item className="customHoverdrop">
                    <div className="customHover"  >
                        My Learning
                    </div>
                    <div className="submenuresp"> */}
        {/* <div id={"idOnboardingMng"+from} className="customHover b-b-1" onClick={() => goToMenu('my-onboarding')}>- Onboarding</div>
                        <div id={"idLearningPathMng"+from} className="customHover b-b-1" onClick={() => goToMenu('learning-path')}>- Learning Path</div> */}
        {/* <div id={"idMyCoursesMng"+from} className="customHover b-b-1" onClick={() => goToMenu('courses')}>- Courses</div>
                        <div id={"idMyVideosMng"+from} className="customHover b-b-1" onClick={() => goToMenu('videos')}>- Videos</div>
                        <div id={"idMyEventsMng"+from} className="customHover b-b-1" onClick={() => goToMenu('events')}>- Events</div> */}
        {/* <div id={"idMyCertificatesMng"+from} className="customHover b-b-1" onClick={() => goToMenu('my-certificates')}>- Certificates</div>
                        <div id={"idMyBadgesMng"+from} className="customHover b-b-1" onClick={() => goToMenu('my-badges')}>- Badges</div>
                        <div id={"idMyLearningPointsMng"+from} className="customHover b-b-1" onClick={() => goToMenu('learning-points')}>- Learning Points</div> */}
        {/* </div> */}
        {/* <NavDropdown.Item className="customHover b-b-1" onClick={() => goToMenu('favorites')}>Wishlist</NavDropdown.Item> */}
        {/* </NavDropdown.Item> */}
        {/* <NavDropdown.Item id={"idMyToolboxMng"+from} className="customHover" onClick={() => goToMenu('toolbox')}>My Toolbox</NavDropdown.Item>
                {false && <NavDropdown.Item id={"idMyNetworkMng"+from} className="customHover" onClick={() => goToMenu('role-request')}>My Network</NavDropdown.Item>}
                <NavDropdown.Item id={"idMyReportMng"+from} className="customHover" onClick={() => goToMenu('report')}>Reports</NavDropdown.Item>  */}
        {authBroker.payload?.user?.config?.learning_points !== "false" && (
          <NavDropdown.Item
            className="customHoverdrop"
            onClick={() => {
              goToMenu("toolbox");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="#344054"
            >
              <path d="M5.32943 3.27152C6.56252 2.83314 7.9923 3.10743 8.97927 4.0944C10.1002 5.21531 10.3019 6.90735 9.5843 8.23378L20.293 18.9436L18.8788 20.3579L8.16982 9.64869C6.84325 10.3668 5.15069 10.1653 4.02952 9.04415C3.04227 8.0569 2.7681 6.62659 3.20701 5.39326L5.44373 7.62994C6.02952 8.21572 6.97927 8.21572 7.56505 7.62994C8.15084 7.04415 8.15084 6.0944 7.56505 5.50862L5.32943 3.27152ZM15.6968 5.15506L18.8788 3.38729L20.293 4.80151L18.5252 7.98349L16.7574 8.33704L14.6361 10.4584L13.2219 9.04415L15.3432 6.92283L15.6968 5.15506ZM8.97927 13.2868L10.3935 14.701L5.09018 20.0043C4.69966 20.3948 4.06649 20.3948 3.67597 20.0043C3.31334 19.6417 3.28744 19.0698 3.59826 18.6773L3.67597 18.5901L8.97927 13.2868Z"></path>
            </svg>{" "}
            ToolBox
          </NavDropdown.Item>
        )}
        {authBroker.payload?.user?.config?.learning_points !== "false" && (
          <NavDropdown.Item
            className="customHoverdrop"
            onClick={() => goToMenu("learning-points")}
          >
            <div id={"idMyAccount" + from} className="customHover">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="#344054"
              >
                <path d="M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 5V19H20V5H4ZM6 7H8V9H6V7ZM8 11H6V13H8V11ZM6 15H8V17H6V15ZM18 7H10V9H18V7ZM10 15H18V17H10V15ZM18 11H10V13H18V11Z"></path>
              </svg>{" "}
              Learning Points
            </div>
          </NavDropdown.Item>
        )}
        {
          <NavDropdown.Item
            className="customHoverdrop"
            onClick={() => goToMenu("credit-points")}
          >
            <div id={"idMyAccount" + from} className="customHover">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="#344054"
              >
                <path d="M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM7 6H11V10H7V6ZM7 12H17V14H7V12ZM7 16H17V18H7V16ZM13 7H17V9H13V7Z"></path>
              </svg>{" "}
              Reward Points
            </div>
          </NavDropdown.Item>
        }
        <NavDropdown.Item
          className="customHoverdrop"
          onClick={() => {
            localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true" ?  stopImpersonating():signOut();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6M6 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H6"
              stroke="#344054"
              strokeWidth="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>{" "}
          {localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
            ? "Stop Impersonation"
            : "Sign out"}
        </NavDropdown.Item>
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('admin-dashboard')}>Administrator Dashboard</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('role-request')}>Requests for Role</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('my-dashboard')}>My Dashboard</NavDropdown.Item>
                <NavDropdown.Item className="customHover" onClick={() => goToMenu('my-onboarding')}>My Onboarding</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('role-request')}>My Team Area</NavDropdown.Item>
                <NavDropdown.Item className="customHover" onClick={() => goToMenu('courses')}>My Courses</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('learning-path')}>My Learning Paths</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('learning-points')}>My Learning Points</NavDropdown.Item>
                <NavDropdown.Item className="customHover" onClick={() => goToMenu('my-certificates')}>My Certificates</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('cart')}>My Cart</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('orders')}>My Orders</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('credit-points')}>My Reward Points</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" href="notifications.html">My Notifications</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('learningCenter')}>My Learning Center</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('broker-events')}>My Broker Events</NavDropdown.Item> */}
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('events')}>My Events</NavDropdown.Item>
                <NavDropdown.Item className="customHover" onClick={() => goToMenu('favorites')}>My Wishlist</NavDropdown.Item> */}
        {/* {!isPremiumUser && <NavDropdown.Item className="customHover" onClick={() => goToMenu('membership')}>Upgrade to Premium</NavDropdown.Item>} */}
      </>
    );
  };

  const brokerMenu = () => {
    return (
      <>
        <NavDropdown.Item
          className="customHover"
          onClick={() => goToMenu("admin-dashboard")}
        >
          Administrator Dashboard
        </NavDropdown.Item>
        <NavDropdown.Item
          className="customHover"
          onClick={() => goToMenu("courses")}
        >
          My Courses
        </NavDropdown.Item>
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('cart')}>My Cart</NavDropdown.Item> */}
        <NavDropdown.Item
          className="customHover"
          onClick={() => goToMenu("orders")}
        >
          My Orders
        </NavDropdown.Item>
        {/* <NavDropdown.Item className="customHover" onClick={() => goToMenu('report')}>Reports</NavDropdown.Item> */}
        <NavDropdown.Item
          className="customHover"
          onClick={() => {
            localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true" ?  stopImpersonating():signOut();
          }}
        >
          {localStorage.getItem(SessionKeys.IS_IMPERSONATED) === "true"
            ? "Stop Impersonation"
            : "Sign out"}
        </NavDropdown.Item>
      </>
    );
  };

  useEffect(() => {
    dispatch(setCongratClassName("step1"));
  }, []);

  useEffect(() => {
    // console.log('congratClassName: ', congratClassName)
    setBlinkEffect(congratClassName);
  }, [congratClassName]);

  return (
    <>
      {/* Start:Menu dropdown */}
      <Loader start={isLoading} />
      <NavDropdown
        show={showDropDown}
        title={
          <div
            id={"idClickProfile" + from}
            className={`${blinkEffect} blcink d-flex flex-row align-items-center`}
            onClick={() => {
              if (showDropDown) {
                dispatch(setShowDropDown(false));
              } else {
                dispatch(setShowDropDown(true));
              }
            }}
          >
            {userRole !== "customer" && false ? premiumIcon() : null}
            {/* {is_impersonated && impersonatedIcon()} */}

            <div className="userimgbox">
              {authBroker?.payload?.user?.profile_img === undefined ||
              authBroker?.payload?.user?.profile_img === "" ||
              _.isEmpty(authBroker?.payload?.user?.profile_img) ? (
                <>
                  <div className="without-profile">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </>
              ) : (
                <ReactRoundedImage
                  image={
                    authBroker.payload.user?.profile_img !== undefined &&
                    authBroker.payload.user?.profile_img !== ""
                      ? authBroker.payload.user?.profile_img
                      : "/images/avatar.svg"
                  }
                  roundedSize="0"
                  imageWidth="40"
                  imageHeight="40"
                />
              )}
            </div>
            {from === "Web" && false && (
              <div className="text-left textuser">
                Hello!
                <br /> <span className="namefirst">{name}</span>
              </div>
            )}
            {/* {cartCount > 0 && !(window.location.pathname.includes('/cart')) ?
                        <div className='cursor-pointer cart-item-report' style={{
                            marginTop: '-20px'
                        }} onClick={() => {

                            setTimeout(() => { dispatch(setShowDropDown(false)) }, 100)
                            navigateToDetails()
                        }} title="cart" data-title="cart">
                            <img width={32} height={32} src='/images/cart_blank.png' />
                            <p className='cart-text' >{(cartCount < 10 ? '0' : '') + cartCount}</p>
                        </div> : ""} */}
          </div>
        }
        className="profile-nav"
      >
        {!isLoggedIn && renderLoginSignup()}
        {(userRole === "realtor" || userRole === "customer") && realtorMenu()}
        {userRole === "host" && hostInstructorMenu()}
        {userRole === "instructor" && hostInstructorMenu()}
        {userRole === "broker" && brokerMenu()}
        {userRole === "admin" && brokerMenu()}
        {userRole === "manager" && managerMenu()}
      </NavDropdown>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        confirmAction={confirmAction}
        isConfirm={isConfirm}
        isRightIcon={true}
      />
      {/* End:Menu dropdown */}
    </>
  );
};

export default ProfileMenuSection;
